import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import { Scrollbars } from 'react-custom-scrollbars';
import AdvancedSearchForm from './AdvancedSearchForm';

const styles = {
  formButtons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    flexWrap: 'wrap',
    marginTop: 24,
  },
  centerButton: {
    margin: '0 10px',
  },
};

export class AdvancedSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      queryTargets: ['self', 'mother', 'father', 'offspring'],
    };

    this.handleSearch = this.handleSearch.bind(this);
  }

  handleSearch() {
    const { getAdvancedSearchResults, advSearchIsExpanded, advancedSearchFilters } = this.props;
    if (!advSearchIsExpanded) return;
    const searchParameter = advancedSearchFilters.map((filter) => {
      const params = (typeof filter.value !== 'object')
        ? { value: filter.value } : { min: filter.value[0], max: filter.value[1] };
      return (
        {
          target: filter.target,
          field_name: filter.attribute,
          params,
        }
      );
    });
    getAdvancedSearchResults(searchParameter);
  }

  render() {
    const { queryTargets } = this.state;
    const {
      searchAttributes,
      classes,
      advancedSearchFilters,
      addFilter,
      removeFilter,
      updateFilter,
      clearFilters,
    } = this.props;
    return (
      <div className={classes.root}>
        <Scrollbars autoHeight autoHeightMax={200}>
          {advancedSearchFilters.map(filter => (
            <div key={filter.index}>
              <AdvancedSearchForm
                filter={filter}
                removeFilter={removeFilter}
                queryTargets={queryTargets}
                attributes={searchAttributes}
                updateFilter={updateFilter}
                filterAmount={advancedSearchFilters.length}
              />
              <Divider />
            </div>
          ))}
        </Scrollbars>
        <div className={classes.formButtons}>
          <Button onClick={clearFilters} variant="contained" color="primary">
            {'Reset'}
          </Button>
          <Button onClick={addFilter} variant="contained" className={classes.centerButton} color="secondary">
            {'Add filter'}
          </Button>
          <Button onClick={this.handleSearch} variant="contained" type="submit">
            {'Search'}
          </Button>
        </div>
      </div>
    );
  }
}

AdvancedSearch.propTypes = {
  searchAttributes: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  getAdvancedSearchResults: PropTypes.func.isRequired,
  classes: PropTypes.shape().isRequired,
  advSearchIsExpanded: PropTypes.bool.isRequired,
  advancedSearchFilters: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  addFilter: PropTypes.func.isRequired,
  removeFilter: PropTypes.func.isRequired,
  updateFilter: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
};

export default withStyles(styles)(AdvancedSearch);



// WEBPACK FOOTER //
// ./src/components/search/advanced-search/AdvancedSearch.jsx